// apps/client/src/ui/save.ts
export const clientSaveConfig = {
  MAX_SAVE_BYTES: 8_000_000 as const,
  MAX_REPLAY_BYTES: 30_000_000 as const,
  SAVE_KIND: "razmak-save" as const,
  // UI save-wrapper version (distinct from SNAPSHOT_VERSION/REPLAY_VERSION).
  // Tests import this constant instead of hardcoding the number.
  SAVE_VERSION: 1 as const,
};

// apps/client/src/ui/owners.ts
export const clientOwnersConfig = {
  // Fifth green picked against blue/red/yellow/purple with CVD simulations
  // (Machado 2009, full severity): ΔE ≥ 22 vs red under protanopia, ΔE ≥ 27 vs
  // yellow in every mode, and no pair tighter than the pre-existing blue/purple
  // deuteranopia pair. See owners.test.ts ("owner colors stay distinct under
  // color vision deficiency").
  OWNER_COLORS: [
    "#4aaee8",
    "#e65d4f",
    "#efcd71",
    "#9b7bed",
    "#3cb371",
    "#a5dddd",
    "#ff2777",
    "#16e580",
  ],
  OWNER_MINIMAP: [
    "#71b8ec",
    "#ed7770",
    "#efcd71",
    "#b39bff",
    "#54c496",
    "#1ecb57",
    "#c490c7",
    "#d848a8",
  ],
};

// apps/client/src/telemetry/client.ts
export const clientTelemetryConfig = {
  WINDOW_MS: 10_000 as const,
  GPU_PENDING_MAX: 8 as const,
  CAPACITY: 1200 as const,
  NUMERIC_VALUE_MAX_LENGTH: 32 as const,
  EXCEPTION_FRAMES_MAX_ITEMS: 30 as const,
};

export const clientPreferences = {
  volume: { music: 0.5, effects: 0.8, voice: 0.8 },
  speed: { slow: 0.5, normal: 1, fast: 1.5 },
  graphics: "medium" as const,
  frameRate: 60 as const,
  touchGraphics: "low" as const,
  difficulty: "normal" as const,
  language: "fa" as const,
  storage: {
    controls: "razmak.controls",
    quality: "razmak.quality",
    frameRate: "razmak.frameRate",
    speed: "razmak.speed",
    language: "razmak.language",
    hudPerf: "razmak.hudperf",
    hudScale: "razmak.hudscale",
    playerName: "razmak_name",
  },
  settingsCacheRevisions: 16,
};

export const clientFrameConfig = {
  maxDeltaSeconds: 0.15,
  effectsHistoryMax: 8192,
  fallbackMs: 250,
  capToleranceMs: 1.5,
  idleAfterMs: 1000,
  idleFrameRate: 10,
  replaySkipTicksPerBatch: 120,
};

export const downloadConfig = {
  revokeDelayMs: 5000,
};
